import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

// API
import { alterarSenhaUsuario } from '../servicos/cadastroServico';

function AlterarSenhaPontoMototaxi() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    senha_atual: '',
    nova_senha: '',
    confirma_nova_senha: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.nova_senha !== form.confirma_nova_senha) {
      alert('A nova senha e a confirmação não coincidem.');
      return;
    }

    try {
      const cookies = Cookies.get();
      const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

      // 🔹 Montando o FormData
      const formData = new FormData();
      formData.append('senha_atual', form.senha_atual);
      formData.append('nova_senha', form.nova_senha);
      formData.append('confirma_nova_senha', form.confirma_nova_senha);
      formData.append('dadosCookies', JSON.stringify(dadosCookies));

      console.log('Enviando FormData para alterar senha...');

      const response = await alterarSenhaUsuario(formData);

      alert('Senha alterada com sucesso!');
      navigate('/pagina-ponto-mototaxi');
    } catch (error) {
      console.error('Erro ao alterar senha:', error);
      alert('Erro ao alterar senha. Verifique os dados e tente novamente.');
    }
  };

  return (
    <div className="card p-4 shadow-sm" style={{ maxWidth: '500px', margin: '2rem auto' }}>
      <div className="card-body">
        <h3 className="text-center mb-4">Alterar Senha</h3>

        <form onSubmit={handleSubmit}>
          <div className="form-floating mb-3">
            <input
              type="password"
              className="form-control"
              id="senha_atual"
              name="senha_atual"
              placeholder="Senha atual"
              value={form.senha_atual}
              onChange={handleChange}
              required
            />
            <label htmlFor="senha_atual">Senha atual</label>
          </div>

          <div className="form-floating mb-3">
            <input
              type="password"
              className="form-control"
              id="nova_senha"
              name="nova_senha"
              placeholder="Nova senha"
              value={form.nova_senha}
              onChange={handleChange}
              required
            />
            <label htmlFor="nova_senha">Nova senha</label>
          </div>

          <div className="form-floating mb-4">
            <input
              type="password"
              className="form-control"
              id="confirma_nova_senha"
              name="confirma_nova_senha"
              placeholder="Confirmar nova senha"
              value={form.confirma_nova_senha}
              onChange={handleChange}
              required
            />
            <label htmlFor="confirma_nova_senha">Confirmar nova senha</label>
          </div>

          <button type="submit" className="btn btn-primary w-100">
            Salvar Senha
          </button>
        </form>
      </div>
    </div>
  );
}

export default AlterarSenhaPontoMototaxi;
